import moment from 'moment-timezone';

import { ChartDataIntervals } from 'app/shared/model/charts/chart-data-intervals.enum';

export const ChartDataSettings = {
  currentWeek: {
    xAxisLabel: moment().format('MMMM YYYY'),
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM'),
      },
    },
  },
  lastWeek: {
    xAxisLabel: moment().subtract(1, 'week').format('MMMM YYYY'),
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM'),
      },
    },
  },
  currentMonth: {
    xAxisLabel: moment().format('MMMM YYYY'),
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM'),
      },
      [ChartDataIntervals.Week]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM'),
      },
    },
  },
  lastMonth: {
    xAxisLabel: moment().subtract(1, 'month').format('MMMM YYYY'),
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM'),
      },
      [ChartDataIntervals.Week]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM'),
      },
    },
  },
  currentQuarter: {
    xAxisLabel: moment().format('Qo [Quarter of] YYYY'),
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM'),
        barPadding: 2,
      },
      [ChartDataIntervals.Week]: {
        xAxisLabel: moment().format('Qo [Quarter of] YYYY'),
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM'),
      },
      [ChartDataIntervals.Month]: {
        xAxisLabel: moment().format('Qo [Quarter of] YYYY'),
        xAxisTickFormatter: (tick) => moment(tick).format('MMMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('MMMM'),
      },
    },
  },
  lastQuarter: {
    xAxisLabel: moment().subtract(1, 'quarter').format('Qo [Quarter of] YYYY'),
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM, YYYY'),
        barPadding: 2,
      },
      [ChartDataIntervals.Week]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM, YYYY'),
      },
      [ChartDataIntervals.Month]: {
        xAxisTickFormatter: (tick) => moment(tick).format('MMMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('MMMM YYYY'),
      },
    },
  },
  currentYear: {
    xAxisLabel: moment().format('YYYY'),
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM, YYYY'),
      },
      [ChartDataIntervals.Week]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM'),
      },
      [ChartDataIntervals.Month]: {
        xAxisTickFormatter: (tick) => moment(tick).format('MMMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('MMMM'),
      },
      [ChartDataIntervals.Quarter]: {
        xAxisTickFormatter: (tick) => moment(tick).format('Qo [Quarter of] YYYY'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('Qo [Quarter of] YYYY'),
      },
    },
  },
  lastYear: {
    xAxisLabel: moment().subtract(1, 'year').format('YYYY'),
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM, YYYY'),
      },
      [ChartDataIntervals.Week]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM, YYYY'),
      },
      [ChartDataIntervals.Month]: {
        xAxisTickFormatter: (tick) => moment(tick).format('MMMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('MMMM YYYY'),
      },
      [ChartDataIntervals.Quarter]: {
        xAxisTickFormatter: (tick) => moment(tick).format('[Q]Q YYYY'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('[Q]Q YYYY'),
      },
    },
  },
  custom: {
    xAxisLabel: 'Custom',
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM, YYYY'),
      },
      [ChartDataIntervals.Week]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM, YYYY'),
      },
      [ChartDataIntervals.Month]: {
        xAxisTickFormatter: (tick) => moment(tick).format('MMMM, YYYY'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('MMMM YYYY'),
      },
      [ChartDataIntervals.Quarter]: {
        xAxisTickFormatter: (tick) => moment(tick).format('[Q]Q YYYY'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('[Q]Q YYYY'),
      },
    },
  },
  all: {
    xAxisLabel: 'All time',
    intervals: {
      [ChartDataIntervals.Day]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM, YYYY'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM, YYYY'),
      },
      [ChartDataIntervals.Week]: {
        xAxisTickFormatter: (tick) => moment(tick).format('D, MMM, YYYY'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('D, MMMM, YYYY'),
      },
      [ChartDataIntervals.Month]: {
        xAxisTickFormatter: (tick) => moment(tick).format('MMMM, YYYY'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('MMMM YYYY'),
      },
      [ChartDataIntervals.Quarter]: {
        xAxisTickFormatter: (tick) => moment(tick).format('[Q]Q YYYY'),
        xAxisTooltipFormatter: (tick) => moment(tick).format('[Q]Q YYYY'),
      },
    },
  },
};
